import { useEffect, useMemo, useState } from "react";
import prepareForOptions from "~services/utils/prepareForOptions";
import { db } from "~/db/db";

const useFamiliaProdutoPrecoRegra = ({ grupoProduto = 0, gruposProduto, familiasDisponiveis, replicacao = false }) => {
  const [familiasProduto, setFamiliasProduto] = useState([]);

  useEffect(() => {
    const fetchFamiliasProduto = async () => {
      let query = db.familiaProdutos;
      let result = [];

      if (gruposProduto?.length > 0 && !grupoProduto) {
        let idsArray = gruposProduto.map((g) => g.id);

        if (idsArray.length > 0) {
          query = query.where("grupoMaterialId").anyOf(idsArray);
        }
      } else if (familiasDisponiveis) {
        query = query
          .where("id")
          .anyOf(familiasDisponiveis)
          .filter((a) => a.ativo && a.nome != "" && (!grupoProduto || a.grupoMaterialId === grupoProduto));
      } else if (grupoProduto > 0) {
        query = query
          .where("grupoMaterialId")
          .equals(grupoProduto)
          .filter((a) => a.ativo && a.nome != "");
      } else {
        query = query.filter((a) => a.ativo && a.nome != "");
      }

      if (replicacao) query = query.filter((a) => a.replicacaoAtiva !== false);

      await query.each((item) => result.push(item));

      setFamiliasProduto(result);
    };

    fetchFamiliasProduto();
  }, [grupoProduto, gruposProduto, familiasDisponiveis, replicacao]);

  const optionFamiliasProduto = useMemo(() => {
    return prepareForOptions(
      (familiasProduto || []).sort((a, b) => a.nome?.localeCompare(b.nome)),
      ["nome"],
      "id"
    );
  }, [familiasProduto]);

  return {
    optionFamiliasProduto,
  };
};

export default useFamiliaProdutoPrecoRegra;
